export function commentsSlider() {
    $(".comments-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
    }).on('beforeChange', function () {
        $(this).find('iframe').remove();
        $(this).find('.video').removeClass('show-video');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/commentsSlider.js